const observers: ResizeObserver[] = [];

export default function masonry($container: HTMLElement): void {
    observers.forEach((observer) => {
        observer.disconnect();
    });

    observers.length = 0;

    $container.querySelectorAll<HTMLElement>('.masonry').forEach(($masonry) => {
        const items = Array.from($masonry.querySelectorAll<HTMLElement>('.entry'));

        if (!items.length) {
            return;
        }

        $masonry.style.position = 'relative';

        const layout = (): void => {
            const containerWidth = $masonry.clientWidth;
            const firstItem = items[0];

            if (!firstItem || !firstItem.offsetWidth) {
                return;
            }

            firstItem.style.width = '';
            firstItem.style.position = '';

            const firstItemWidth = firstItem.offsetWidth;

            const cols = Math.max(Math.floor((containerWidth + 1) / firstItemWidth), 1);
            const colYs = Array(cols).fill(0);
            const colWidthPercent = 100 / cols;

            for (const item of items) {
                const minY = Math.min(...colYs);
                const col = colYs.indexOf(minY);

                Object.assign(item.style, {
                    position: 'absolute',
                    left: `${(col / cols) * 100}%`,
                    top: `${minY}px`,
                    width: `${colWidthPercent}%`
                });

                colYs[col] = minY + item.offsetHeight;
            }

            $masonry.style.height = `${Math.max(...colYs)}px`;
        };

        const observer = new ResizeObserver(layout);
        observer.observe($masonry);
        observers.push(observer);

        layout();

        $masonry.style.visibility = 'visible';
    });
}
